/** API 调用统计 */
export const STATISTICS = {
    tagSuggest: 0,
    tagSearch: 0,
};
